import React, { ReactElement, useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { confirmRegistration, passwordReset } from '../http';
import { ErrorI } from '../util/functions';
import { AlertI, Button } from './Button';
import { InputField } from './InputField';
import { Pin } from './Pin';
interface Props {
  setStep: (step: number) => void;
}

export default function ConfirmSignup(props: Props): ReactElement {
  const [alert, setAlert] = useState<AlertI | null>(null);
  const [pin, setPin] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [triggerResendVerify, setTriggerResendVerify] = useState<boolean>(false);
  const [error, setError] = useState<ErrorI>({});

  const navigate = useNavigate();

  const handleVerify = async (evt: FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    if (pin.length === 0) {
      setError({ ...error, pin: 'requiredAlert' });
    } else {
      setLoading(true);
      confirmRegistration(pin)
        .then((res) => {
          setAlert({
            type: 'success',
            message: 'profileVerificationAlert',
          });
          setTimeout(() => {
            localStorage.removeItem('email');
            localStorage.removeItem('step');
            localStorage.removeItem('pin_time');
            setLoading(false);
            navigate('/', { replace: true });
          }, 500);
        })
        .catch(function (e) {
          const error = e?.response?.data;
          setAlert({
            type: 'error',
            message: error?.message,
          });
          setLoading(false);
        });
    }

    //verify api request goes here
  };

  const onResendVerifyEmail = async () => {
    //Resend Verify Email api request goes here
    const email = localStorage.getItem('email');

    if (email?.length) {
      const res = await passwordReset(email);
      if (res.status === 201) {
        setAlert({
          type: 'success',
          message: 'verificationPinSentAlert',
        });
        setTriggerResendVerify(!triggerResendVerify);
        localStorage.removeItem('pin_time');
      } else {
        setAlert({
          type: 'error',
          message: 'emailNotFound',
        });
        setTimeout(() => {
          props.setStep(1);
        }, 1000);
      }
    }
  };

  return (
    <React.Fragment>
      <h3 style={{ color: 'black' }}>Complete your profile</h3>
      <Pin triggerResendVerify={triggerResendVerify} />
      <form className="form-container" onSubmit={handleVerify}>
        <div>
          <InputField
            type="text"
            onChange={(e) => {
              setAlert(null);
              if (e.target.value.length) {
                setError({ ...error, pin: null });
              } else {
                setError({ ...error, pin: 'requiredAlert' });
              }
              setPin(e.target.value);
            }}
            placeholder="Enter PIN"
          />
          <span className="error">{error?.pin ? 'PIN is required' : null}</span>
        </div>
        <div className="flex-b" style={{ width: '95%' }}>
          <div className="text-btn" onClick={onResendVerifyEmail}>
            <span>Resend PIN to email</span>
          </div>
          <div
            className="text-btn"
            onClick={() => {
              localStorage.removeItem('step');
              localStorage.removeItem('email');
              localStorage.removeItem('pin_time');
              props.setStep(1);
            }}
          >
            <span>Cancel registration</span>
          </div>
        </div>

        <Button style={{ marginTop: '10px' }} alert={alert} loading={loading} disabled={loading}>
          Verify & Continue
        </Button>
      </form>
    </React.Fragment>
  );
}
